import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DataNetwork } from 'src/app/shared/model/data-network';
import { Network } from 'src/app/shared/model/network';
import { NetworkService } from 'src/app/shared/service/network.service';
import { EpgDataService } from 'src/app/shared/service/epg-data.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
    bucketBaseUrl: string;
    private unsubscription$: Subject<void>;

    networks: Network[];
    loadingNetworks = false;
    networks$: Observable<Network[]>;
    style: any = {};

    activateStyle: any = {
        opacity: '1',
        filter: 'none',
        clicked: false
    };
    deactivateStyle: any = {
        opacity: '1',
        filter: 'none',
        clicked: false
    };

    selectedNetwork$ = new Subject<Network>();
    selectedNetworkCode$ = this.selectedNetwork$.pipe(map(n => n.code));

    constructor(
        private networkService: NetworkService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.bucketBaseUrl = environment.bucketUrlVideo;
        this.unsubscription$ = new Subject<void>();
    }

    ngOnInit() {
        this.loadingNetworks = true;
        this.route.url.subscribe(() => {
            this.loadNetworks();
        });
    }

    private loadNetworks() {
        let nets: Observable<Network[]>;

        if (this.loadingNetworks === false) {
            this.networks = null;
            this.loadingNetworks = true;
        }

        nets = this.networkService.getNetworks$();

        nets.pipe(takeUntil(this.unsubscription$))
            .subscribe(networks => {
                console.log('Networks loaded:', networks);
                this.mapperNetworks(networks);
            })
            .add(() => this.loadingNetworks = false);
    }

    private mapperNetworks(networks: Network[]): void {
        const activeNetworks = networks.filter(network => network.logo !== "" && network.active);
        activeNetworks.forEach(network => this.style[network.code] = { ...this.deactivateStyle });
        this.networks$ = of(activeNetworks.slice(0, 16));
    }

    ngOnDestroy(): void {
        this.unsubscription$.next();
        this.unsubscription$.complete();
    }

    clickNetwork(network: Network) {
        this.router.navigate(['/epg/networks'], { state: { network } });
    }

    getBucketVideoUrl(fileName: string): string {
        return `${this.bucketBaseUrl}${fileName}`;
    }
}
